import { webVersionUi } from '../app/webVersion';
import { createStore } from './createStore';

// The web version keeps an inspection only in this browser (Owner decision list 2026-10-19 item 45, model A:
// no cloud sync). Browsers may clear a site's data when space runs short unless the site is granted
// persistent storage; this asks for it once per session and remembers the answer so the Home screen can say
// plainly whether this browser promised to keep the data. Never runs in the iPhone / Android app.
export interface WebStorageState {
  checked: boolean;
  // true = the browser promised to keep it · false = it did not · null = the browser has no such promise
  persisted: boolean | null;
}

export const webStorageStore = createStore<WebStorageState>({ checked: false, persisted: null });

export function isWebVersion(): boolean {
  return webVersionUi();
}

let asking: Promise<void> | null = null;

export function requestPersistentWebStorage(): Promise<void> {
  if (!isWebVersion() || webStorageStore.get().checked) return Promise.resolve();
  asking ??= (async () => {
    const storage = typeof navigator !== 'undefined' ? navigator.storage : undefined;
    if (!storage || typeof storage.persist !== 'function') {
      webStorageStore.set(() => ({ checked: true, persisted: null }));
      return;
    }
    try {
      const already = typeof storage.persisted === 'function' ? await storage.persisted() : false;
      const persisted = already || (await storage.persist());
      webStorageStore.set(() => ({ checked: true, persisted }));
    } catch {
      webStorageStore.set(() => ({ checked: true, persisted: false }));
    }
  })();
  return asking;
}

export function resetWebStorageForTests(): void {
  asking = null;
  webStorageStore.set(() => ({ checked: false, persisted: null }));
}
